import { connect } from "react-redux";
import { createSelector } from "reselect";

import {
  toggleMaterial,
  showEstimatedQuantitiesSelector,
} from "../../redux/settings";
import MaterialTotals from "./MaterialTotals";

const material = createSelector(
  (state) => state.events.events,
  (state) => state.settings.entity,
  showEstimatedQuantitiesSelector,
  (events, entity, showEstimatedQuantities) => {
    switch (entity) {
      case "purchaseOrders": {
        // Purchase orders are already unique because they can only be scheduled once
        const totals = events
          .filter((e) => e.purchaseOrder)
          .map((e) => e.purchaseOrder)
          .reduce((items, p) => [...items, ...p.items], [])
          .filter((i) => i.quantity && i.item && i.item.itemType)
          .reduce((totals, i) => {
            let group = totals[i.item.itemType.id] || {
              id: i.item.itemType.id,
              name: i.item.itemType.name,
              quantity: 0,
              label:
                i.item.itemType.inventoryQuantityLabel ||
                i.item.itemType.quantityLabel,
            };
            group.quantity += i.quantity;
            totals[i.item.itemType.id] = group;
            return totals;
          }, {});

        return Object.values(totals);
      }
      default: {
        const uniqueJobs = events
          .filter((e) => e.job && !e.tentative)
          .map((e) => e.job)
          .reduce((unique, job) => ({ ...unique, [job.id]: job }), {});

        const totals = Object.values(uniqueJobs)
          .reduce((items, j) => [...items, ...j.items], [])
          .filter(
            (i) =>
              (showEstimatedQuantities
                ? i.estimatedQuantity
                : i.proposedQuantity) &&
              i.item &&
              i.item.itemType
          )
          .reduce((totals, i) => {
            const quantity = showEstimatedQuantities
              ? i.estimatedQuantity
              : i.proposedQuantity;
            const label = showEstimatedQuantities
              ? i.item.itemType.estimatedQuantityLabel
              : i.item.itemType.quantityLabel;
            let group = totals[i.item.itemType.id] || {
              id: i.item.itemType.id,
              name: i.item.itemType.name,
              quantity: 0,
              label: label,
            };
            group.quantity += quantity;
            totals[i.item.itemType.id] = group;
            return totals;
          }, {});

        return Object.values(totals);
      }
    }
  }
);

const mapStateToProps = (state) => ({
  entity: state.settings.entity,
  material: material(state),
  materialEnabled: state.settings.materialEnabled,
  showEstimatedQuantities: showEstimatedQuantitiesSelector(state),
});

const mapDispatchToProps = {
  onToggleMaterial: toggleMaterial,
};

export default connect(mapStateToProps, mapDispatchToProps)(MaterialTotals);
